import React, { useState, useRef, useEffect } from 'react'
import MessageModal from 'shared/components/MessageModal'
import { Answer, MessageType, VestigingEnum } from 'shared/models/Enum'
import { IAfleverafspraakGroepKoppeling } from 'shared/models/IAfleverafspraakGroepKoppeling'
import { IAfleverafspraakLocatieKoppeling } from 'shared/models/IAfleverafspraakLocatieKoppeling'
import { IOrderType } from 'shared/models/IOrderType'
import {
  IModalObjectReference,
  IModalReference,
} from 'shared/models/References'
import { IResponse } from 'shared/models/IResponse'
import { CustomerDeliveryLocationsService } from 'services/CustomerDeliveryLocationsService'
import { CustomerModel } from 'shared/models/CutomerDeliveryLocations/CustomerModel'
import {
  isAgreement,
  isDeliveryLocation,
  isGroupLink,
  isLocationLink,
  RowType,
} from './DeliveryLocationsAgreementData'
import { DeliveryLocationModel } from 'shared/models/CutomerDeliveryLocations/DeliveryLocationModel'
import CustomerDeliveryLocation from '../LosseKoperComponents/CustomerDeliveryLocation'
import { LocationType } from 'shared/components/CustomerDeliveryLocationComponents/LocationTypeLink'

interface IProps {
  customer: CustomerModel
  service: CustomerDeliveryLocationsService
  warehouse: VestigingEnum
  activeRow: RowType
  possibleOrderTypes: IOrderType[]
  onChangeCopy: (row: IAfleverafspraakLocatieKoppeling) => void
  onError: (errorMessage: string) => void
  onLoading: (isLoading: boolean) => void
  onReloadRequired: () => void
  onEditDeliveryLocation: (location: DeliveryLocationModel) => void
  onHide: () => void
}

export default (props: IProps) => {
  const linkGroupRef =
    useRef<IModalObjectReference<IAfleverafspraakGroepKoppeling>>()
  const linkLocationRef =
    useRef<IModalObjectReference<IAfleverafspraakLocatieKoppeling>>()
  const deleteMessageRef = useRef<IModalReference>()
  const linkDeliveryLocRef =
    useRef<IModalObjectReference<DeliveryLocationModel>>()

  const [copyRow, setCopyRow] = useState<IAfleverafspraakLocatieKoppeling>()

  const activeRowIsAgreement = (): boolean => {
    return isAgreement(props.activeRow)
  }

  const activeRowIsDeliveryLocation = (): boolean => {
    return isDeliveryLocation(props.activeRow)
  }

  const activeRowIsLocationLink = (): boolean => {
    return isLocationLink(props.activeRow)
  }

  const activeRowIsGroupLink = (): boolean => {
    return isGroupLink(props.activeRow)
  }

  const activeRowAsLocationLink = (): IAfleverafspraakLocatieKoppeling => {
    if (activeRowIsLocationLink) {
      return props.activeRow as IAfleverafspraakLocatieKoppeling
    } else {
      return null
    }
  }

  const activeRowAsGroupLink = (): IAfleverafspraakGroepKoppeling => {
    if (activeRowIsGroupLink) {
      return props.activeRow as IAfleverafspraakGroepKoppeling
    } else {
      return null
    }
  }

  const activeRowAsDeliveryLocationLink = (): DeliveryLocationModel => {
    if (activeRowAsDeliveryLocationLink) {
      return props.activeRow as DeliveryLocationModel
    } else {
      return null
    }
  }

  const addDeliveryLocationClick = () => {
    linkDeliveryLocRef.current.show(getNewLink(LocationType.Dag))
  }

  const addStandardLocationClick = () => {
    linkDeliveryLocRef.current.show(getNewLink(LocationType.Standaard))
  }

  const editClick = () => {
    if (activeRowIsLocationLink()) {
      linkLocationRef.current.show(activeRowAsLocationLink())
    } else if (activeRowIsGroupLink()) {
      linkGroupRef.current.show(activeRowAsGroupLink())
    } else if (activeRowIsDeliveryLocation()) {
      linkDeliveryLocRef.current.show(activeRowAsDeliveryLocationLink())
    }
  }

  const removeClick = () => {
    deleteMessageRef.current.show()
  }

  const getDeleteMessage = (): string => {
    let objectType = 'onbekend'
    if (activeRowIsLocationLink()) {
      objectType = 'locatiekoppeling'
    } else if (activeRowIsGroupLink()) {
      objectType = 'groepkoppeling'
    } else if (activeRowIsDeliveryLocation()) {
      objectType = 'locatiekoppeling'
    }

    return `Weet u zeker dat u deze ${objectType} wilt verwijderen?`
  }

  const deleteAnswer = (answer: Answer) => {
    if (answer === Answer.Yes) {
      if (activeRowIsDeliveryLocation()) {
        const request = props.service.deleteLocationLink(
          props.warehouse,
          props.customer.customerNumber,
          activeRowAsDeliveryLocationLink().deliveryagreementlocationid
        )
        handleLoading(request)
      }
    }
  }

  const getNewLink = (type: LocationType): DeliveryLocationModel => {
    console.log('get new link')
    //initialiseren nieuwe item op basis van klantAar
    var tmpLink: DeliveryLocationModel = {
      combination: null,
      days: '1,2,3,4,5,6,0',
      deliveryagreementlocationid: 0,
      deliveryagreementype: type,
      ordertype: props.possibleOrderTypes
        .map(function (o) {
          return o.value
        })
        .join(','),
      warehouseid: props.customer.warehouseId,
      warehousename: '',
      deliveryagreementreference:
        activeRowAsDeliveryLocationLink().deliveryagreementreference,
      deliveryagreementid:
        activeRowAsDeliveryLocationLink().deliveryagreementid,
      name: activeRowAsDeliveryLocationLink().name,
      shiptocustomergln: '',
      shiptolocationid: 0,
      shiptolocationgln: '',
      shiptolocationname: '',
      shiptowarehousename: '',
      routetocustomergln: '',
      routetocustomerid: null,
      routetolocationglnid: null,
      routetolocationgln: '',
      routetolocationname: '',
      routetowarehousename: '',
      startdate: undefined,
      enddate: undefined,
      deliveryagreementenddate: activeRowAsDeliveryLocationLink().deliveryagreementenddate,
      comment: undefined,
    }
    console.log(tmpLink)
    return tmpLink
  }

  const handleLoading = (request: Promise<IResponse>) => {
    props.onLoading(true)
    request
      .then(result => {
        if (!result.success) {
          props.onError(result.errorMessage)
        } else {
          props.onError(null)
          props.onReloadRequired()
        }
      })
      .finally(() => {
        props.onLoading(false)
      })
  }

  const pasteLocationLinkClick = () => {
    // const request = props.service.saveLocationLink({
    //     afleverafspraakLocatieKoppelingId: 0,
    //     eindDatumtijd: copyRow.eindDatumtijd,
    //     ingangsDatumtijd: copyRow.ingangsDatumtijd,
    //     klantAfleverAfspraakId: activeRowAsAgreement().klantAfleverafspraakId,
    //     klantAfleverafspraak: activeRowAsAgreement(),
    //     locatieGlnId: copyRow.locatieGlnId,
    //     locatieGln: copyRow.locatieGln,
    //     magCombineren: false
    // }, props.customer);
    // handleLoading(request);
  }

  return (
    <React.Fragment>
      {!!props.customer && (
        <table>
          <tbody>
            <tr>
              <td>
                <div className='row no-gutters'>
                  <div className='col'></div>
                  {!copyRow && (
                    <div className='col-auto mr-2'>
                      <button
                        className='btn btn-primary'
                        disabled={props.customer == null}
                        onClick={addStandardLocationClick}
                      >
                        Voeg Standaard toe
                      </button>
                    </div>
                  )}
                  {!copyRow && (
                    <div className='col-auto mr-2'>
                      <button
                        className='btn btn-primary'
                        disabled={props.customer == null}
                        onClick={addDeliveryLocationClick}
                      >
                        Voeg Dag toe
                      </button>
                    </div>
                  )}
                  {!!copyRow && (
                    <div className='col-auto mr-2'>
                      <button
                        className='btn btn-secondary'
                        onClick={() => setCopyRow(null)}
                      >
                        Stop kopieren
                      </button>
                    </div>
                  )}
                  {!!copyRow && (
                    <div className='col-auto mr-2'>
                      <button
                        className='btn btn-primary'
                        disabled={!activeRowIsAgreement()}
                        onClick={pasteLocationLinkClick}
                      >
                        Plakken koppeling
                      </button>
                    </div>
                  )}
                  {!copyRow && (
                    <div className='col-auto mr-2'>
                      <button
                        className='btn btn-primary'
                        disabled={
                          !activeRowAsDeliveryLocationLink() ||
                          (!!activeRowAsDeliveryLocationLink() &&
                            activeRowAsDeliveryLocationLink()
                              .shiptolocationgln == null) ||
                          activeRowAsDeliveryLocationLink().shiptolocationgln ==
                            ''
                        }
                        onClick={() => editClick()}
                      >
                        Wijzigen
                      </button>
                    </div>
                  )}
                  {!copyRow && (
                    <div className='col-auto'>
                      <button
                        className='btn btn-primary'
                        disabled={
                          !activeRowAsDeliveryLocationLink() ||
                          (!!activeRowAsDeliveryLocationLink() &&
                            activeRowAsDeliveryLocationLink()
                              .shiptolocationgln == null) ||
                          activeRowAsDeliveryLocationLink().shiptolocationgln ==
                            ''
                        }
                        onClick={() => removeClick()}
                      >
                        Verwijder koppeling
                      </button>
                    </div>
                  )}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      )}
      {props.customer != null && activeRowIsDeliveryLocation() && (
        <CustomerDeliveryLocation
          customer={props.customer}
          ref={linkDeliveryLocRef}
          orderTypes={props.possibleOrderTypes}
          warehouse={props.warehouse}
          service={props.service}
          onHide={props.onHide}
        />
      )}

      <MessageModal
        ref={deleteMessageRef}
        title='Verwijderen'
        message={getDeleteMessage()}
        messageType={MessageType.YesNo}
        onAnswer={deleteAnswer}
      />
    </React.Fragment>
  )
}
